import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { tokens } from "@/shared/design-system/tokens";

const chartFilterTransition = keyframes`
  from {
    opacity: 0.55;
    transform: scale(0.985);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const ChartCanvasContainer = styled.div<{
  $animate: boolean;
  $height: number;
}>`
  position: relative;
  width: 100%;
  height: ${({ $height }) => `${$height}px`};
  min-width: 0;
  overflow: visible;
  transform-origin: center;
  animation: ${({ $animate }) =>
    $animate ? css`${chartFilterTransition} 280ms ease-out` : "none"};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export type ChartLegendSize = "sm" | "md";

export const LegendList = styled.ul<{ $size: ChartLegendSize }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ $size }) =>
    $size === "md" ? tokens.spacing.mmd : tokens.spacing.sm};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const LegendItem = styled.li<{ $size: ChartLegendSize }>`
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr) auto;
  align-items: center;
  gap: ${tokens.spacing.sm};
  color: ${tokens.colors.basics[0]};
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: ${({ $size }) =>
    $size === "md"
      ? tokens.typography.fontSize.sm
      : tokens.typography.fontSize.xs};
  font-weight: ${tokens.typography.fontWeight.normal};
  line-height: 1.25;
`;

export const LegendColor = styled.span<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: ${tokens.borderRadius.full};
  background: ${({ $color }) => $color};
`;

export const LegendLabel = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const LegendValue = styled.span`
  font-size: ${tokens.typography.fontSize.xs};
  font-weight: ${tokens.typography.fontWeight.semibold};
  white-space: nowrap;
`;
